import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import authProvider from '../utils/authProvider';
import { cookieOrStorageToken } from '../utils/cookieToken';

const LoginPage = () => {

  const navigate = useNavigate();

  const { searchParams } = new URL(window.location.href);
  const code = searchParams.get('code');

  const href = window.location.href;
  const isHashed = href.includes('hashed');

  const params = useParams();
  useEffect(() => {

    let cancelled = false;

    const run = async () => {

      if (isHashed) {

        authProvider.login({
          code: null,
          credentials: {
            username: params.username,
            key: params.key,
          },
        });
        return;

      }

      if (code) {

        await authProvider.login({ code });
        if (!cancelled) {

          navigate('/');

        }
        return;

      }

      // Cookie SSO or an existing localStorage session — do not bounce to FusionAuth.
      const token = await cookieOrStorageToken();
      if (cancelled) {

        return;

      }
      if (token) {

        // cookieOrStorageToken reloads when it consumed a cookie; otherwise go home.
        navigate('/');
        return;

      }

      authProvider.login({ code: null });

    };

    run();
    return () => {

      cancelled = true;

    };

    // Mount-only: OAuth code / hashed credentials come from the initial URL.

  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <div>Redirecting...</div>;

};

export default LoginPage;
